import { createContext, useState, useContext, ReactNode } from 'react';
import Loader from '../components/loaders/Loader';

// Loader context definition
type LoaderContextType = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
};

// Create context
const LoaderContext = createContext<LoaderContextType>({} as LoaderContextType);

// Custom hook to use loader context
export const useLoader = () => useContext(LoaderContext);

// LoaderProvider to wrap around the entire app
export const LoaderProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      {/* Render children and the loader */}
      {children}
      <Loader />  {/* Loader component is rendered globally */}
    </LoaderContext.Provider>
  );
};